import { areaInitialGet } from "common/panel/panel_common";
import { AreaSource, PlaySource } from "type/panel/Panel.type";

export const areaDeleteInd = (
  areas: AreaSource[],
  ind: number
): AreaSource[] => {
  const result: AreaSource[] = [
    ...areas.slice(0, ind),
    ...areas.slice(ind + 1),
  ];

  return result;
};

export const areaInitialAdd = (areas: AreaSource[]): AreaSource[] => {
  const result: AreaSource[] = [...areas, areaInitialGet()];

  return result;
};

export const areaSourceUpdate = (
  areas: AreaSource[],
  selectedAreaInd: number,
  sourceUpdated: PlaySource[]
): AreaSource[] => {
  const result: AreaSource[] = [...areas];
  result[selectedAreaInd].source = sourceUpdated;

  return result;
};
